exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-soft-info[data-v-5f2af0dc]{background-color:rgba(0,201,255,.1);color:#00c8ff;width:2.2rem;height:2.2rem;display:flex;align-items:center;justify-content:center}.bg-soft-success[data-v-5f2af0dc]{background-color:rgba(0,201,167,.1)!important}.bg-soft-warning[data-v-5f2af0dc]{background-color:rgba(245,202,153,.1)!important}", ""]);

// exports
